import React from "react";
import { SafetyTestsTab, sampleAgent } from "./index";
import { AgentLayout } from "./AgentLayout";

export const SafetyTestsPage: React.FC = () => {
  // In a real app, you would fetch the agent data based on agentId
  const agent = sampleAgent;

  return (
    <AgentLayout activeTab="safety-tests">
      <SafetyTestsTab agent={agent} />
    </AgentLayout>
  );
};
